export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 50 },
  { key: '3', headerName: 'Category', field: 'audit_categoryname', hide: false, width: 200 },
  { key: '4', headerName: 'Audit Sub Category', field: 'audit_subcategoryname', hide: false, width: 400 },
  {
    key: '5', headerName: 'Audit Point', field: 'audit_pointlist', hide: false, width: 2200
  },
];
